import axios from 'axios'

export default {
  methods: {
    addToCart(product) {
      let cart = JSON.parse(localStorage.getItem("cart")) || [];

      if (cart.length === 0) {
        let item = {
          shopmarketplace_id: product.id,
          product_id: product.product_shop.product.id,
          product_name: product.product_shop.name,
          product_description: product.product_shop.name,
          sku: product.product_shop.product.skus[0].code,
          sale_price: product.price,
          shop_price: product.price,
          warehouse_price: product.price,
          vendor_price: product.price,
          amount: product.price,
          img: product.product_shop.product.product_image,
          lieferzeit: product.product_shop.product.skus[0].delivery_time,
          shop_name: product.product_shop.shop_name,
          stock: product.product_shop.product.stock,
          // subtotal: product.price * 1,
          qty: 1,
          shop_id: product.product_shop.shop_id,
          warehouse_id: product.product_shop.warehouse_id,
          vendor_id: product.product_shop.vendor_id,
          tax: "test",
          properties: "test",
          is_light: false,
        };
        cart.push(item);
        this.$store.commit("setCart", item);
        localStorage.setItem("cart", JSON.stringify(cart));
        this.$notify({
          group: "cart",
          title: "Cart",
          text: "Artikel in den Warenkorb gelegt",
        });
      } else {
        let item = cart.find((item) => {
          return item.product_id === product.product_shop.product.id;
        });
        // console.log(item);
        if (item) {
          // check if is not new item
          this.$notify({
            group: "cart",
            title: "Cart",
            text: "Produkt ist bereits im Warenkorb vorhanden",
          });
        } else {
          let item = {
            shopmarketplace_id: product.id,
            product_id: product.product_shop.product.id,
            product_name: product.product_shop.name,
            product_description: product.product_shop.name,
            sku: product.product_shop.product.skus[0].code,
            sale_price: product.price,
            shop_price: product.price,
            warehouse_price: product.price,
            vendor_price: product.price,
            amount: product.price,
            img: product.product_shop.product.product_image,
            lieferzeit: product.product_shop.product.skus[0].delivery_time,
            shop_name: product.product_shop.shop_name,
            stock: product.product_shop.product.stock,
            // subtotal: product.price * 1,
            qty: 1,
            shop_id: product.product_shop.shop_id,
            warehouse_id: product.product_shop.warehouse_id,
            vendor_id: product.product_shop.vendor_id,
            tax: "test",
            properties: "test",
            is_light: false,
          };
          cart.push(item);
          this.$store.commit("setCart", item);
          localStorage.setItem("cart", JSON.stringify(cart));
          this.$notify({
            group: "cart",
            title: "Cart",
            text: "Artikel in den Warenkorb gelegt",
          });
        }
      }

      axios.post(`${process.env.VUE_APP_API}/button-click`, {
        product_id: this.product.id,
        button: 'ADD_TO_CART'
      })
    },

    addLighting(lightning) {
      let cart = JSON.parse(localStorage.getItem("cart")) || [];

      if (cart.length === 0) {
        let item = {
          // product_id: lightning[0].id,
          light_id: lightning[0].id,
          code: lightning[0].code,
          product_name: lightning[0].name,
          img: lightning[0].image,
          sale_price: lightning[0].sale_price > 0 ? lightning[0].sale_price : lightning[0].price,
          qty: 1,
          amount: lightning[0].sale_price > 0 ? lightning[0].sale_price : lightning[0].price,
          is_light: true,
          tax: "test",
          properties: "test",
          shop_id: 1,
          warehouse_id: 1,
          vendor_id: 1,
        };

        cart.push(item);
        this.$store.commit("setCart", item);
        localStorage.setItem("cart", JSON.stringify(cart));
        this.$notify({
          group: "cart",
          title: "Cart",
          text: "Artikel in den Warenkorb gelegt",
        });
      } else {
        let item = cart.find((item) => {
          return item.product_id === lightning[0].id;
        });
        if (item) {
          // check if is not new item
          this.$notify({
            group: "cart",
            title: "Cart",
            text: "Produkt ist bereits im Warenkorb vorhanden",
          });
        } else {
          let item = {
            light_id: lightning[0].id,
            code: lightning[0].code,
            product_name: lightning[0].name,
            img: lightning[0].image,
            sale_price: lightning[0].price,
            qty: 1,
            amount: lightning[0].price,
            is_light: true,
            tax: "test",
            properties: "test",
            shop_id: 1,
            warehouse_id: 1,
            vendor_id: 1,
          };
          cart.push(item);
          this.$store.commit("setCart", item);
          localStorage.setItem("cart", JSON.stringify(cart));
          this.$notify({
            group: "cart",
            title: "Cart",
            text: "Artikel in den Warenkorb gelegt",
          });
        }
      }
    },
  },
};
